import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "sq";
    const saved = localStorage.getItem("bt_lang");
    if (saved && translations[saved]) return saved;
    return "sq"; // Default to Albanian regardless of browser language
  });

  useEffect(() => {
    localStorage.setItem("bt_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.sq;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
